export default {
  // 主导航菜单
  home: "首页",
  analysisAndResearch: "研判分析",
  evidenceManagement: "调证管理",
  dataBoard: "数据看板",
  caseToolbox: "办案工具箱",
  helpCenter: "帮助中心",
  apiService: "APIs",
  permissionManagement: "权限管理",

  // 研判分析子菜单
  caseAnalysis: "案件分析",
  balanceAnalysis: "余额分析",
  labelManagement: "标签管理",
  aiModel: "AI模型",
  addressMonitoring: "地址监控",
  remarkManagement: "备注管理",

  // 调证管理子菜单
  evidenceAdvice: "调证建议",
  evidenceUsers: "调证用户",
  evidenceUpload: "调证上传",
  evidenceInvestigation: "调证协查",

  // 数据看板子菜单
  transactionData: "交易数据",
  balanceData: "余额数据",

  // 办案工具箱子菜单
  addressCompletion: "地址补全",
  hashCompletion: "哈希补全",
  tgSentimentAnalysis: "TG公群舆情分析",

  // 帮助中心子菜单
  productFunction: "产品功能介绍",
  judicialReference: "司法判例参考",
  prosecutionBook: "起诉书",
  policyRegulation: "政策法规",
  blockchainKnowledge: "区块链行业知识",
  blockchainCaseInvestigation: "区块链案件侦查实录",

  // 权限管理子菜单
  labelList: "标签管理",
  userList: "用户列表",
  roleManagement: "角色管理",
  userLog: "用户日志",
  adminLog: "管理日志",

  // 其他
  dataLargeScreen: "数据大屏",
  userCenter: "用户中心",
  userFeedback: "用户反馈",
  logout: "退出登录",
};
